/**
 * @generated SignedSource<<8679db5e3163479a5b24ef5b1a043bcf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PolUploadInput = {
  clientMutationId?: string | null | undefined;
  polFileUploadId: UUID;
};
export type useUploadCheck_RetryMutation$variables = {
  input: PolUploadInput;
};
export type useUploadCheck_RetryMutation$data = {
  readonly retryPolUpload: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type useUploadCheck_RetryMutation = {
  response: useUploadCheck_RetryMutation$data;
  variables: useUploadCheck_RetryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PolUploadPayload",
    "kind": "LinkedField",
    "name": "retryPolUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUploadCheck_RetryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUploadCheck_RetryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "52e9e4fedb502a36f01c0e4c2e963257",
    "id": null,
    "metadata": {},
    "name": "useUploadCheck_RetryMutation",
    "operationKind": "mutation",
    "text": "mutation useUploadCheck_RetryMutation(\n  $input: PolUploadInput!\n) {\n  retryPolUpload(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "45e355473b30e0edd0742f63e6bec382";

export default node;
